import React from 'react';
import AppPageHero from '../AppPageHero';

/**
 * Standard app hero — same shell as Dialog Flows (via AppPageHero): orbs, Bricolage type, CTA rail.
 */
const PageHeader = ({
  eyebrow,
  lead,
  title,
  subtitle,
  description,
  actions,
  aside,
  compact = false,
  className = '',
}) => (
  <AppPageHero
    eyebrow={eyebrow}
    lead={lead}
    title={title}
    subtitle={subtitle}
    description={description}
    actions={actions}
    aside={aside}
    compact={compact}
    className={className}
  />
);

export default PageHeader;
